import { Injectable } from '@angular/core';
import { SearchboxModelv2 } from 'src/app/models/searchBoxv2/searchbox-modelv2';

declare const staticValues;

@Injectable({
  providedIn: 'root',
})
export class StaticValuesUtils {
static isHighAndHeavy(): boolean {
const userInformation = staticValues?.segmentUserInformation;
return (
      userInformation ?
          'HIGH' === userInformation.income  &&
          userInformation.travelFrequency === 'HEAVY' &&
          'HIGH' === userInformation.incomeAccuracy &&
          'HIGH'  ===  userInformation.travelFrequencyAccuracy
     : false
    );
  }

  static getCurrencySymbol(code: string): string {
    let currencySymbol = staticValues?.availableCurrencies.find( currency => currency.currencyCode === code);
    return currencySymbol ? currencySymbol.value : null;
  }

  static getSBoxHtml(): string {
    return staticValues?.searchBoxHTML;
  }

  static getMediaPicturesEndpoint(): string {
    return staticValues?.mediaPicturesEndpoint;
  }

  static isWebview(): boolean {
    return staticValues?.isWebview;
  }

  static isMobile(): boolean {
    return staticValues?.isMobile;
  }

  static getABTests(): string {
    return staticValues?.abtests;
  }

  static getCartActivation(): boolean {
    return staticValues?.cartActivation ?? false;
  }

  static getPageViewId(): string {
    return staticValues?.pageViewId;
  }

  static getStaticUrl(): string {
    return staticValues?.staticUrl;
  }

  static isLoyaltyEnabled(): boolean {
    return staticValues.isLoyaltyEnabled;
  }
  
  static getIsPigDeal(): boolean {
    return staticValues.isPigDeal;
  }

  static setIsPigDeal(isPigDeal: boolean): void {
    staticValues.isPigDeal = isPigDeal;
  }

  static getTripPlannerEnabled(): boolean {
    return staticValues.tripPlannerEnabled;
  }

  static setCouponFilter(value): boolean {
    return staticValues.couponFilter = value;
  }

  static getCouponFilter(): boolean {
    return staticValues.couponFilter;
  }

  static setPromotions(value): string {
    return staticValues.promotions = value;
  }

  static getPromotions(): string {
    return staticValues.promotions;
  }

  static isPartnerAvailableCurrenciesEnabled(): boolean {
    return staticValues.isPartnerAvailableCurrenciesEnabled;
  }

  static isPartnerDualPriceLayoutEnabled(): boolean {
    return staticValues.isPartnerDualPriceLayoutEnabled;
  }

  static getAvailableCurrencies() {
    return staticValues.availableCurrencies;
  }

  static getItemIdentifierConfiguration(): any {
    return staticValues.identifier;
  }

  static isPartner(): boolean {
    return staticValues?.isPartner;
  }

  static searchBoxModel(): SearchboxModelv2  {
    return staticValues?.searchBoxModel;
  }

}
